import { Plus, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const AttributeEditor = ({ value, onChange, testid = "attr" }) => {
  const rows = Object.entries(value || {});
  const update = (i, k, v) => {
    const next = [...rows];
    next[i] = [k, v];
    onChange(Object.fromEntries(next));
  };
  return (
    <div className="space-y-2" data-testid={`${testid}-editor`}>
      {rows.map(([k, v], i) => (
        <div key={i} className="flex gap-2">
          <Input className="w-2/5 h-9" value={k} onChange={(e) => update(i, e.target.value, v)} placeholder="Key" data-testid={`${testid}-key-${i}`} />
          <Input className="flex-1 h-9" value={v} onChange={(e) => update(i, k, e.target.value)} placeholder="Value" data-testid={`${testid}-value-${i}`} />
          <Button type="button" size="icon" variant="ghost" className="h-9 w-9" onClick={() => onChange(Object.fromEntries(rows.filter((_, j) => j !== i)))} data-testid={`${testid}-remove-${i}`}><X className="h-4 w-4" /></Button>
        </div>
      ))}
      <Button type="button" variant="ghost" size="sm" className="text-[#F59E0B]" onClick={() => onChange({ ...value, [`attribute_${rows.length + 1}`]: "" })} data-testid={`${testid}-add`}>
        <Plus className="h-3.5 w-3.5 mr-1" />Add attribute
      </Button>
    </div>
  );
};
